module.exports = __webpack_public_path__ + "img/workbenchSelected.3c71d374.svg";